import React from "react";
import { motion } from "framer-motion";

// Static motion configs — module-level for stable referential identity.
const STEP_INITIAL = { opacity: 0, y: 18 };
const STEP_WHILE_IN_VIEW = { opacity: 1, y: 0 };
const STEP_VIEWPORT = { once: true, amount: 0.2 };
const stepTransition = (i) => ({ duration: 0.55, delay: i * 0.07 });

const STEPS = [
  { n: "01", icon: "fa-bag-shopping", title: "Escolha o Produto", desc: "Selecione no catálogo o brinde ideal para o objetivo da sua marca." },
  { n: "02", icon: "fa-paper-plane", title: "Solicite Orçamento", desc: "Receba uma proposta personalizada com prazo e condições comerciais." },
  { n: "03", icon: "fa-image", title: "Envie sua Arte", desc: "Compartilhe o logotipo ou layout — nossa equipe faz a finalização." },
  { n: "04", icon: "fa-check-double", title: "Aprovação Digital", desc: "Você aprova o mockup digital com todos os detalhes antes da produção." },
  { n: "05", icon: "fa-industry", title: "Produção", desc: "Iniciamos a fabricação com acompanhamento e controle de qualidade." },
  { n: "06", icon: "fa-truck-fast", title: "Entrega", desc: "Receba seus brindes em todo o Brasil com rastreamento completo." },
];

export const Process = () => {
  return (
    <section id="processo" data-testid="process-section" className="mn-section bg-[#0c0c0c] text-white">
      <div className="mn-container">
        <div className="max-w-3xl mb-14">
          <span className="mn-eyebrow" style={{ color: "var(--mn-gold)" }}>
            <span className="!bg-[var(--mn-gold)]" />
            Processo
          </span>
          <h2 className="font-serif-display font-extrabold text-[2.25rem] sm:text-[2.75rem] lg:text-[3.25rem] mt-4 leading-tight text-white">
            Um processo claro, do briefing <br className="hidden md:block" />
            <span style={{ color: "var(--mn-gold)" }}>à entrega final.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-white/70">
            Etapas claras e transparentes. Você acompanha cada fase do projeto sem surpresas.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6" data-testid="process-grid">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={STEP_INITIAL}
              whileInView={STEP_WHILE_IN_VIEW}
              viewport={STEP_VIEWPORT}
              transition={stepTransition(i)}
              className="relative border border-white/10 rounded-[4px] p-7 hover:border-[var(--mn-gold)] transition-colors duration-300"
              data-testid={`process-step-${s.n}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-serif-display text-[3rem] font-extrabold leading-none" style={{ color: "var(--mn-gold)" }}>
                  {s.n}
                </span>
                <i className={`fa-solid ${s.icon} text-2xl text-white/80`} />
              </div>
              <h3 className="font-serif-display font-bold text-xl mt-6 text-white">{s.title}</h3>
              <p className="mt-3 text-sm text-white/65 leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
